import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter } from 'react-router-dom';
import 'bootstrap/js/dist/carousel.js';
import "./Carousel.css";
import LoadingIcon from "./common/LoadingIcon";
import { giveCookieConsent } from "../redux/actions/authActions";
import "./Home.css";
import $ from 'jquery';
import { Helmet } from 'react-helmet';

function Home({
    allowCookies,
    giveCookieConsent,
    history
}) {

    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        $("a").on('click', function (event) {
            if (this.hash !== "") {
                event.preventDefault();
                var hash = this.hash;

                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800);
            }
        });

    }, []);

    function getYear() {
        var dt = new Date();
        return dt.getFullYear(); 
    }

    function acceptCookies() {
        giveCookieConsent(); 
    }

    return (
        processing ?
            <LoadingIcon />  :
            (
                <React.Fragment>
                    <Helmet>
                        <meta name="title" content="Ride Social - Global GPX Cycle Route Sharing | JustGoRide" />
                        <meta name="description" content="Search, Create and Ride - Social networking in the real world! Discover great new new cycle routes by learning about how to make the most of the free GPS mapping tools and GPX cycle route resources on offer from JustGoRide. Whether you ride mountain bikes, gravel bikes, road bikes or unicycles, JustGoRide is the first place to go if you want to explore the great outdoors on your bike!" />
                        <meta name="keywords" content="global gpx route sharing, download gpx route files, upload gpx route files, create gpx route files, search gpx route file catalog, bike rides and routes in gpx format, cycling social network" />
                    </Helmet>
                    {!allowCookies &&
                        <div className="cookie-consent">
                            <p><Link to="/about/cookies">We use cookies to make interactions with our websites and services easy and meaningful. For more information about the cookies we use, click here.</Link></p>
                            <button className="btn btn-info" onClick={acceptCookies} >Accept Cookies and Close this Banner</button>
                        </div>
                    }
                    <nav className="mobile-nav d-md-none">
                        <div className="row">
                            <div className="col-4">
                                <a href="#network-feature">
                                    <div className="item">
                                        <i className="fad fa-users"></i>
                                        Network
                                    </div>
                                </a>
                            </div>
                            <div className="col-4">
                                <a href="#routes-feature">
                                    <div className="item">
                                        <i className="fad fa-route"></i>
                                        Routes
                                    </div>
                                </a>
                            </div>
                            <div className="col-4">
                                <a href="#ride-feature">
                                    <div className="item">
                                        <i className="fad fa-calendar-check"></i>
                                        Ride
                                    </div>
                                </a>
                            </div>
                        </div>
                    </nav>
                    <nav className="sidebar homepage-sidebar d-none d-md-block">
                        <div className="sidebar-sticky">
                            <a href="#top">
                                <div className="item">
                                    <i className="fad fa-arrow-circle-up"></i>
                                    Top
                                </div>
                            </a>
                            <a href="#network-feature">
                                <div className="item">
                                    <i className="fad fa-users"></i>
                                    Rider Network
                                </div>
                            </a>
                            <a href="#routes-feature">
                                <div className="item">
                                    <i className="fad fa-route"></i>
                                    Plan Routes
                                </div>
                            </a>
                            <a href="#ride-feature">
                                <div className="item">
                                    <i className="fad fa-calendar-check"></i>
                                    Organise Rides
                                </div>
                            </a>
                        </div>
                    </nav>
                    
                    <div className="homepage" id="top">
                        <div className="homepage-panel">
                            <div className="gradient"></div>
                            <div className="contents splash">
                                <h1 className="top-title">RIDE SOCIAL</h1>
                                <p>
                                    Join a network of riders, discover new places to ride and then plan your next adventure.
                                    <br />
                                    <Link to="/signup" className="btn btn-info">Sign Up</Link>
                                </p>
                            </div>
                            <div className="d-none d-md-block">
                                <a href="#feature-summary">
                                    <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                                </a>
                            </div>
                            <div className="d-md-none">
                                <a href="#network-feature">
                                    <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                                </a>
                            </div>    
                        </div>
                    </div>
                    <div className="content-panel-features d-none d-md-block" id="feature-summary">
                        <div className="gradient"></div>
                        <div className="row features">
                            <div className="feature col-4">
                                <a href="#network-feature">
                                    <div>
                                        <i className="fad fa-users"></i>
                                        <h4>RIDER NETWORK</h4>
                                        <p>
                                            Connect with other riders and join or create groups within
                                            your region. There is no better way to broaden your horizons
                                            than sharing riding knowledge and experiences.
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div className="feature col-4">
                                <a href="#routes-feature">
                                    <div>
                                        <i className="fad fa-route"></i>
                                        <h4>ROUTES</h4>
                                        <p>
                                            Explore exisiting routes or create your own and share them with your network.
                                            Whether you ride road, gravel or mtb, there are thousands of routes to discover
                                            enabling you to plan your next adventure.
                                        </p>
                                    </div>
                                </a>
                                <Link to="/signup" className="btn btn-info mt-4">Sign Up</Link>
                            </div>
                            <div className="feature col-4">
                                <a href="#ride-feature">
                                    <div>
                                        <i className="fad fa-calendar-check"></i>
                                        <h4>RIDE</h4>
                                        <p>
                                            Discuss and plan your next ride within your groups before setting up a calendar of
                                            group events to organise your riding  and set out your goals for the season.
                                        </p>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <a href="#network-feature">
                            <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                        </a>
                    </div>
                    
                    <div className="content-panel-feature network-feature" id="network-feature">
                        <div className="gradient"></div>
                        <div className="row feature">
                            <div className="col-sm-12 col-md-6">
                                <h1><i className="fad fa-users"></i> RIDER NETWORK</h1>
                                <p>
                                    With a host of features to meet up and socialise with you riding contacts,
                                    JustGoRide has all you need to organise your riding social life. Follow riders,
                                    create and join groups, share routes, discuss riding topics and plan events.
                                    Join the growing JustGoRide network and discover the benefits of group riding. 
                                </p>
                                <Link to="/signup" className="btn btn-info mt-4">Sign Up</Link>
                            </div>
                            <div className="col-sn-12 col-md-6 d-none d-md-block">
                                <div style={{ padding: "10px" }}>
                                    <img className="routes-feature-image" alt="map" src="/resources/images/network.png" />
                                </div>
                            </div>
                        </div>
                        <a href="#routes-feature">
                            <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                        </a>
                    </div>

                    <div className="content-panel-feature routes-feature" id="routes-feature">
                        <div className="gradient"></div>
                        <div className="row feature">
                            <div className="col-sm-12 col-md-6">
                                <h1><i className="fad fa-route"></i> ROUTES</h1>
                                <p>
                                    JustGoRide has an extensive database of road, gravel and mtb routes on offer
                                    enabling you to explore new places to ride. If you can't find what you are
                                    looking for then the advanced route creation tool can help you pioneer a new
                                    route or trail, or even adapt an existing one to fit your needs.
                                </p>
                                <Link to="/routes/create" className="btn btn-info mt-4">Try the Route Creator!</Link>
                            </div>
                            <div className="col-sn-12 col-md-6 d-none d-md-block">
                                <div style={{ padding: "10px" }}>
                                    <img className="routes-feature-image" alt="map" src="/resources/images/map.png" />
                                </div>
                            </div>
                        </div>
                        <a href="#ride-feature">
                            <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                        </a>
                    </div>

                    <div className="content-panel-feature ride-feature" id="ride-feature">
                        <div className="gradient"></div>
                        <div className="row feature">
                            <div className="col-sm-12 col-md-6">
                                <h1><i className="fad fa-calendar-check"></i> RIDE</h1>
                                <p>
                                    It's time to ride! Organise events based around a route for your
                                    chosen group. Invite all the group members and start the conversation around what kit is
                                    best suited and how many cafe stops will be needed! Access to a consolidated event calendar
                                    is included so you can easily plan your riding across multiple groups. Its never been easier
                                    to make the most of your time on the bike. 
                                </p>
                                <Link to="/signup" className="btn btn-info mt-4">Sign Up</Link>
                            </div>
                            <div className="col-sn-12 col-md-6 d-none d-md-block">
                                <div style={{ padding: "10px" }}>
                                    <img className="routes-feature-image" alt="map" src="/resources/images/date.png" />
                                </div>
                            </div>
                        </div>
                        <a href="#footer">
                            <div className="homepage-scroll bounce"><i className="far fa-arrow-circle-down"></i></div>
                        </a>
                    </div>

                    <div className="homepage-footer" id="footer">
                        <img className="logo" alt="JGR" src="/resources/images/roundel.png" />
                        <ul className="links">
                            <li><Link to="/about" >About</Link></li>
                            <li><Link to="/about/termsandconditions" >Terms and Conditions</Link></li>
                            <li><Link to="/about/privacypolicy" >Privacy and Cookie Policy</Link></li>
                        </ul>
                        <blockquote className="home-quote blockquote text-right pr-2 d-none d-sm-block">
                            <p className="mb-0">“Ride as much or as little, as long or as short as you feel. But ride”</p>
                            <footer className="blockquote-footer">Eddy Merckx</footer>
                        </blockquote>
                        <div className="copyright">Copyright © {getYear()} JustGoRide <i className="fad fa-bicycle"></i></div>
                    </div>
                </React.Fragment>
            )

    );

}

Home.propTypes = {
    giveCookieConsent: PropTypes.func.isRequired,
    allowCookies: PropTypes.bool.isRequired
}

function mapStateToProps(state) {
    return {
        allowCookies: state.allowCookies
    };
}

const mapDispatchToProps = {
    giveCookieConsent
}

export default connect(mapStateToProps, mapDispatchToProps)(Home); 



// WEBPACK FOOTER //
// ./src/components/Home.js